<template>
  <transition name="fade">
    <div v-if="flashMessage" :class="flashMessage.type" class="message">
      <div v-if="flashMessage.index" class="icon"> {{flashMessage.index}} </div>
      <div v-if="flashMessage.icon" class="icon"><i class="far" :class="flashMessage.icon" /></div>
      <div class="content">{{ flashMessage.message }} </div>
      <div v-if="flashMessage.closable" @click="close()" class="close"><i class="far fa-times"></i></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToasterMessage",
  props: ["flashMessage"],
  data() {
    return {
    };
  },
  created() {
    if (this.flashMessage.timeout) {
      setTimeout(() => {
        if (this.flashMessage){
          this.close()
        }
      }, this.flashMessage.timeout);
    }
  },
  methods: {
    close() {
      this.$store.dispatch('removeFlashMessage', this.flashMessage)
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./../../styles/colors";

.fade-enter-active {
  animation: 0.4s cubic-bezier(0.465, 0.183, 0.153, 0.946) scaleCreate;
}
.fade-leave-active {
  animation: 0.2s cubic-bezier(0.465, 0.183, 0.153, 0.946) scaleDestroy;
}
.fade-enter, .fade-leave-to {
}

.message {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  padding: 16px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(#000000, .4);

  .icon {
    margin-right: 8px;
    font-size: 18px;
  }

  .close {
    margin-left: 8px;
    font-size: 18px;
    cursor: pointer;
    color: lightgray;
    padding: 2px;
    transition: color 0.5s;
    &:hover {
      animation: spin .1s ease-in-out;
      color: white;
    }
  }

  &.success {
    background: $color-success;
    color: white;
  }

  &.error {
    background: $color-danger;
    color: white;
  }

  @keyframes spin { 100% { transform:rotate(90deg); } }

  @keyframes scaleCreate {
    from {
      transform: scale(0);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 100;
    }
  }

  @keyframes scaleDestroy {
    from {
      transform: scale(1);
      opacity: 100;
    }
    to {
      transform: scale(0);
      opacity: 0;
    }
  }

}
</style>
